import {
  Box,
  Progress,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepStatus,
  StepTitle,
  VStack
} from "@chakra-ui/react";

interface Props {
  steps: { name: string; [key: string]: any }[];
  activeStep: number;
  activeStepPercent: number;
}

export default function StepsIndicator({
  steps,
  activeStep,
  activeStepPercent
}: Props) {
  return (
    <Stepper gap={0} colorScheme="green" size="xs" index={activeStep}>
      {steps.map((step, index) => {
        const isActive = index === activeStep;
        return (
          <Step key={step.name}>
            <VStack spacing={1}>
              <StepIndicator
                borderColor={isActive ? "secondary.300 !important" : "default"}
                color={isActive ? "secondary.300 !important" : "default"}
                bg="white"
                boxSize={5}
              >
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <Box flexShrink="0">
                <StepTitle>{step.name}</StepTitle>
              </Box>
            </VStack>

            {index < 2 && (
              <Progress
                value={activeStepPercent}
                position="absolute"
                bg={activeStep > index ? "green.500" : "gray.200"}
                height="3px"
                left={4}
                right={4}
                width="full"
                top="10px"
                zIndex={-1}
              />
            )}
          </Step>
        );
      })}
    </Stepper>
  );
}
